
/**
 * Banner success icon —  Filled green circle with white checkmark.
 * Used in Bannger (Success variant).
 */
function BannerSuccessIcon() {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="#62A446"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711L11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L10.5 13.0858L15.2929 8.29289C15.6834 7.90237 16.3166 7.90237 16.7071 8.29289Z" fill="white"/>
        </svg>
    );
}

export default BannerSuccessIcon;